import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Box, Typography, FormControl, TextField, Button } from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import { actions } from '../../../actions';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  formControl: { margin: 1, minWidth: 120 },
  button: { margin: 1 },
  pdfActions: { display: 'flex', justifyContent: 'space-between' },
});

const ReminderAlert = ({ prestobotsConfig, organization }) => {
  const classes = useStyles();
  const appDispatch = useDispatch();
  const [phone, setPhone] = useState('');
  const [actualClientPhones, setActualClientPhones] = useState([]);
  const firestore = useFirestore();

  const { clientPhones } = prestobotsConfig || [];
  useEffect(() => {
    setActualClientPhones(clientPhones && organization && clientPhones[organization.id]);
  }, [prestobotsConfig, organization]);

  return (
    <div>
      {clientPhones &&
      organization &&
      clientPhones[organization.id] &&
      clientPhones[organization.id].length < 2 ? (
        <>
          <Typography sx={{ fontWeight: 'bold', mt: 4 }}>Alerta de recordatorios</Typography>
          <Box display="flex" alignItems="center">
            <FormControl className={classes.formControl} sx={{ minWidth: '200px', my: 4 }}>
              <TextField
                id="standard-basic"
                onChange={(e) => setPhone(e.target.value)}
                value={phone}
                type="text"
                variant="outlined"
                placeholder="Celular de responsable"
              />
            </FormControl>
            <Box mx={1}>
              <Button
                className={classes.button}
                variant="contained"
                color="primary"
                onClick={() => {
                  appDispatch({
                    type: actions.changeLoading,
                    loading: { loading: true, priority: 1 },
                  });

                  clientPhones[organization.id].push(phone);
                  firestore
                    .collection(collections.configurations)
                    .doc(prestobotsConfig.id)
                    .update({
                      clientPhones: clientPhones,
                    })
                    .then(() => {
                      setPhone('');
                    })
                    .finally(() => {
                      appDispatch({
                        type: actions.changeLoading,
                        loading: { loading: false, priority: 1 },
                      });
                    });
                }}
              >
                Añadir
              </Button>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Typography sx={{ fontWeight: 'bold', mt: 4 }}>Alerta de recordatorios para:</Typography>
        </>
      )}
      {actualClientPhones &&
        actualClientPhones.map((e) => (
          <Box key={e} display="flex" alignItems="center">
            <Typography sx={{ minWidth: '300px' }}>{e}</Typography>
            <Delete
              className={classes.pdfActions}
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                appDispatch({
                  type: actions.changeLoading,
                  loading: { loading: true, priority: 1 },
                });
                setActualClientPhones(clientPhones[organization.id].filter((p) => p !== e));
                clientPhones[organization.id] = actualClientPhones;
                firestore
                  .collection(collections.configurations)
                  .doc(prestobotsConfig.id)
                  .update({
                    clientPhones: clientPhones,
                  })
                  .finally(() => {
                    appDispatch({
                      type: actions.changeLoading,
                      loading: { loading: false, priority: 1 },
                    });
                  });
              }}
            />
          </Box>
        ))}
    </div>
  );
};

ReminderAlert.propTypes = {
  prestobotsConfig: propTypes.object,
  organization: propTypes.object,
};

export default ReminderAlert;
